// components/PerformanceTrendChart.jsx
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
} from 'chart.js';
import { formatConfidence } from '../../../../common/common';

// Register chart elements
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip);

const PerformanceTrendChart = ({ top5sku,topCombinations }) => {
  const labelData = [];
  const confidence = [];
  const barColors = [
    '#6366f1', // Indigo
    '#10b981', // Green
    '#f59e0b', // Amber
    '#ef4444', // Red
    '#3b82f6', // Blue
    '#a855f7', // Purple
    '#14b8a6', // Teal
    '#eab308', // Yellow
  ];

  // top5sku.forEach((data, index) => {
  //   confidence.push(data.totalCombination);
  //   labelData.push(data.sku || 'N/A');
  // });

  topCombinations.forEach((data, index) => {
    confidence.push(data.totalPurchasedTogether);
    labelData.push(`${data.antecedents[0].sku} + ${data.consequent[0].sku}`  || 'N/A');
  });

  const data = {
    labels: labelData,
    datasets: [
      {
        label: 'Conversion (%)',
        data: confidence,
        backgroundColor: confidence.map((_, idx) => barColors[idx % barColors.length]),
        borderRadius: 4,
        barThickness: 60,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        ticks: {
          autoSkip: false,
          maxRotation: 15,
          minRotation: 15,
          font: {
            size: 10,
          },
        },
        
      },
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => `${value}`,
          font: {
            size: 10,
          },
        },
        title: {
          display: true,
          text: 'Number of Orders',  
          font: {
            size: 12,
            weight: 'bold',
          },
          color: '#333',
        },
        grid: {
          drawTicks: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw;
            return `Total Orders: ${value}`;
          },
        },
      },
    },
  };

  return (
    <div style={{ height: '40vh', width: '100%', cursor: 'pointer' }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default PerformanceTrendChart;
